
import React, { useState } from "react";
import "./Header.css";
import { useGlobalContext } from "../../context";
import MenuIcon from '@mui/icons-material/Menu';
import TuneIcon from '@mui/icons-material/Tune';
import CloseIcon from '@mui/icons-material/Close';

function Header() {
    
    const {
        navbarData, 
        setNavbarData,
        showFilterBox, 
        setShowFilterBox
    } = useGlobalContext()
    
    const [openMobileMenu, setOpenMobileMenu] = useState(false);
    const handleClick = item => {
        setNavbarData(navbarData => navbarData.map(data => data.id === item.id ? { ...data, active: true } : { ...data, active: false }));
        setOpenMobileMenu(false);
    }
    
    return(
        <div className = "headerBox">
            {
                window.innerWidth >= 760 ?
                    <ul className = "headerMenuList">
                        {
                            navbarData.map(item =>
                                <li
                                    key = { item.id }
                                    style = {{ borderBottom: item.active ? "1px solid" : "none" }}
                                    onClick = { handleClick.bind(this, item) }
                                >
                                    { item.text }
                                </li>
                            )
                        }
                    </ul> 
                    :
                    <div className = "mobileHeaderBox">
                        <MenuIcon 
                            style = {{
                                color: "#3F68B1", 
                                fontSize: "35px", 
                                margin: "10px 25px"
                            }} 
                            onClick = {() => setOpenMobileMenu(true)}
                        />
                        <TuneIcon 
                            style = {{
                                color: "#3F68B1", 
                                fontSize: "35px", 
                                margin: "10px 25px",
                            }} 
                            onClick = {()=> setShowFilterBox(!showFilterBox)}
                        />
                        <div className = "headerMobileBox" 
                             style = {{
                                 display: openMobileMenu ? "flex" : "none"
                             }}
                        >
                            <CloseIcon 
                                style = {{
                                    fontSize: "35px", 
                                    color: "#3F68B1", 
                                    margin: "15px"
                                }} 
                                onClick = {() => setOpenMobileMenu(false)}
                            />
                            <ul className="mobileMenuList">
                                {
                                    navbarData.map(item => 
                                        <li
                                            key = { item.id }
                                            style = {{
                                                borderBottom: item.active ? "1px solid" : "none"
                                            }}
                                            onClick = { handleClick.bind(this, item) }
                                        >
                                            { item.text }
                                        </li>
                                    )  
                                }  
                            </ul> 
                        </div> 
                    </div> 
            } 
        </div>
    ) 
} 

export default Header


